import React__default from 'react';

var ContactCardLayout = function ContactCardLayout(_ref) {
  var authorTitle = _ref.authorTitle,
    authorImage = _ref.authorImage,
    authorNameElement = _ref.authorNameElement,
    automationId = _ref.automationId;
  return /*#__PURE__*/React__default.createElement("div", {
    "automation-id": automationId,
    className: "flex flex-row gap-4 font-sans"
  }, /*#__PURE__*/React__default.createElement("figure", {
    className: "size-[90px] shrink-0 rounded"
  }, authorImage), /*#__PURE__*/React__default.createElement("div", {
    className: "flex flex-col text-p-12/[18px]"
  }, /*#__PURE__*/React__default.createElement("span", {
    "automation-id": "".concat(automationId, "-author-name"),
    className: "text-p-14/[21px]"
  }, authorNameElement), /*#__PURE__*/React__default.createElement("span", {
    "automation-id": "".concat(automationId, "-author-title")
  }, authorTitle)));
};

export { ContactCardLayout };
//# sourceMappingURL=contact-card-layout.esm.js.map
